const initCustomSelects = () => {
  const selects = document.querySelectorAll('select')

  if (! selects.length) {
    return
  }

  selects.forEach((select) => {
    if (
      select.dataset.customSelectReady === 'true' ||
      select.multiple ||
      select.size > 1 ||
      select.closest('.ui-select') ||
      select.classList.contains('select2-hidden-accessible') ||
      select.classList.contains('selectWoo-hidden-accessible') ||
      select.closest('.select2-container') ||
      select.closest('.select2')
    ) {
      return
    }

    const wrapper = document.createElement('div')
    wrapper.className = 'ui-select'

    const toggle = document.createElement('button')
    toggle.type = 'button'
    toggle.className = 'ui-select__toggle'
    toggle.setAttribute('aria-expanded', 'false')

    const menu = document.createElement('div')
    menu.className = 'ui-select__menu'

    const syncFromSelect = () => {
      const selectedOption = select.options[select.selectedIndex]
      toggle.textContent = selectedOption ? selectedOption.textContent || '' : ''

      Array.from(menu.children).forEach((optionButton, index) => {
        const active = index === select.selectedIndex
        optionButton.classList.toggle('is-selected', active)
      })
    }

    Array.from(select.options).forEach((option) => {
      const item = document.createElement('button')
      item.type = 'button'
      item.className = 'ui-select__option'
      item.textContent = option.textContent || ''

      item.addEventListener('click', () => {
        select.value = option.value
        select.dispatchEvent(new Event('change', { bubbles: true }))
        syncFromSelect()
        wrapper.classList.remove('is-open')
        toggle.setAttribute('aria-expanded', 'false')
      })

      menu.appendChild(item)
    })

    toggle.addEventListener('click', () => {
      const open = wrapper.classList.toggle('is-open')
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false')
    })

    const closeMenu = () => {
      wrapper.classList.remove('is-open')
      toggle.setAttribute('aria-expanded', 'false')
    }

    document.addEventListener('click', (event) => {
      if (! wrapper.contains(event.target)) {
        closeMenu()
      }
    })

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMenu()
      }
    })

    window.addEventListener('scroll', closeMenu, { passive: true })
    window.addEventListener('resize', closeMenu)

    select.addEventListener('change', syncFromSelect)

    select.dataset.customSelectReady = 'true'
    select.classList.add('ui-select__native')
    select.parentNode.insertBefore(wrapper, select)
    wrapper.appendChild(select)
    wrapper.appendChild(toggle)
    wrapper.appendChild(menu)
    syncFromSelect()
  })
}

export default initCustomSelects



// WEBPACK FOOTER //
// ./resources/assets/js/components/custom-select.js